import { Component, OnInit, EventEmitter, Output, Inject, OnDestroy, HostListener, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';
import { AuthMyfileService, UserContextType } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { CartModel } from './topbar.model';
import * as signalR from '@microsoft/signalr';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { NotificationResult } from 'src/app/core/models/push/notification-result';
import { NotificationCountResult } from 'src/app/core/models/push/notification-count-result';
import { PreferenceModel } from 'src/app/core/models/preference/preference-model';
import { PreferenceService, PreferenceType } from 'src/app/core/services/preference.service';
import { RequisitionListService } from 'src/app/core/services/list-services/requisition-list.service';
import { BadgeCountResults } from 'src/app/core/models/push/badge-count-results';
import { RequisitionModel } from 'src/app/core/models/requisition/requisition.model';
import { RequisitionViewDataModel } from 'src/app/core/models/requisition/requisition-view-data.model';
import { RequisitionModalService } from 'src/app/core/services/modal-services/requisiton-modal.service';
import {  Observable, Subscription } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { ContactModel } from 'src/app/core/models/contact/contact.model';
import { ModalType } from 'src/app/core/enums/modalTypesEnum';
import { TemplateDocumentType } from 'src/app/core/models/document/document-template-model';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { DomSanitizer } from '@angular/platform-browser';
import { LastActiveService } from 'src/app/core/services/last-active.service';
import { BusinessUnit } from 'src/app/core/models/org/bussiness-unit.model';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { ClientModalService } from 'src/app/core/services/modal-services/client-modal.service';
import { NotificationType } from 'src/app/core/enums/notification-type-enum';
import { BadgeCountService } from 'src/app/core/services/badgecount.service';
import { AIChatModalService } from 'src/app/core/services/modal-services/ai-chat-modal.service';
import { AuthHTTPService } from 'src/app/core/services/auth.http.service';
import { Roles } from 'src/app/core/security/roles';
import { ViewBlogModalService } from 'src/app/core/services/modal-services/view-blog-modal.service';
import { BlogListService } from 'src/app/core/services/list-services/blog-list.service';
import { RequisitionStatus } from 'src/app/core/enums/requisition-status-enum';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  providers: [RequisitionListService],
})
export class TopbarComponent implements OnInit, OnDestroy {
  modalRequisition = ModalType.RequisitionModal

  element: any;
  mode: string | undefined;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  showSearchbar: boolean = false;

  flagvalue: any;
  valueset: any;
  countryName: any;
  userContext!: any;
  cartData!: CartModel[];
  total = 0;
  cart_length: any = 0;
  totalNewNotifications: number = 0;
  errorMessage = '';
  srHubConnection?: signalR.HubConnection = undefined;
  pref!: PreferenceModel;
  userAvatar?: any;
  submitted: boolean = false;

  reqViewData: RequisitionViewDataModel = new RequisitionViewDataModel();
  requisitionCartList!: Observable<RequisitionModel[]>;
  totalCart!: Observable<number>;
  requisitionsCart?: any;

  totalCost: number = 0;

  isLoading!: Observable<Boolean>;
  isLoadingCartVal: boolean = false;

  isCartLoading!: Observable<Boolean>;

  lastActiveDate$: Observable<Date>;
  currentTenant: BusinessUnit = new BusinessUnit;

  LoginType = LoginType;

  isAIChatVisible: boolean = false;

  loginType?: LoginType = this.authMyfileService.currentUserContextValue?.loginType;
  entityType?: EntityTypeEnum = undefined;

  notificationType: NotificationType | undefined = undefined
  notificationUpdate: boolean = false;
  enumNotificationType = NotificationType;

  protected unsubscribe: Subscription[] = [];

  dropDownOpen: boolean = false;
  /***
  * Language Listing
  */
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' },
    { text: 'Española', flag: 'assets/images/flags/spain.svg', lang: 'es' },
    { text: 'Français', flag: 'assets/images/flags/french.svg', lang: 'fr' },
  ];

  constructor(
    @Inject(DOCUMENT) private document: any,
    public languageService: LanguageService,
    public _cookiesService: CookieService,
    public translate: TranslateService,
    private aiChatModalService: AIChatModalService,
    private viewBlogModalService: ViewBlogModalService,
    private blogListService: BlogListService,
    private sanitizer: DomSanitizer,
    private toasterNotificationService: ToasterNotificationService,
    private myfileApiService: MyfileApiService,
    private userPreferenceService: PreferenceService,
    private myRequisitionModalService: RequisitionModalService,
    private requisitionCartListService: RequisitionListService,
    public lastActiveService: LastActiveService,
    private myClientModalService: ClientModalService,
    private badgeCountService: BadgeCountService,
    private authHttpService: AuthHTTPService,
    private authMyfileService: AuthMyfileService,
  ) {
    this.requisitionCartListService.documentTypes = TemplateDocumentType.Document;
    this.requisitionCartListService.createdById = this.authMyfileService.currentUserContextValue?.id;
    this.requisitionCartList = requisitionCartListService.resultItems$;
    this.totalCart = requisitionCartListService.total$;
    this.isLoading = requisitionCartListService.loading$;
    this.lastActiveDate$ = lastActiveService.lastActive$;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth > 767) {
      this.showSearchbar = true
    } else {
      this.showSearchbar = false
    }
  }

  ngOnInit(): void {
    if (window.innerWidth > 767) {
      this.showSearchbar = true
    } else {
      this.showSearchbar = false
    }

    this.userContext = this.authMyfileService.currentUserContextValue;
    this.element = document.documentElement;


    if (this.loginType == this.LoginType.Client) {
      this.entityType = EntityTypeEnum.Client;
    }

    if (this.loginType == this.LoginType.User) {
      this.entityType = EntityTypeEnum.User;
    }

    //preferences init

    var sub1: Subscription = this.userPreferenceService.currentPreference
      .subscribe((data: PreferenceType) => {
        if (data) {
          this.pref = data;
          const val = this.listLang.filter(x => x.lang === this.pref.language);
          this.countryName = val.map(element => element.text);
          if (val.length === 0) {
            if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.svg'; }
          } else {
            this.flagvalue = val.map(element => element.flag);
          }
        }
      });
    this.unsubscribe.push(sub1);
    this.userPreferenceService.getPreference();
    //** end of preferences init */
    this.badgeCountService.getBadgeCount();

    var sub2: Subscription = this.badgeCountService.badgeCountUpdated$
      .subscribe((badgeCounts: BadgeCountResults | undefined) => {
        if (badgeCounts) {

          if (badgeCounts.notificationCount && (this.totalNewNotifications != badgeCounts.notificationCount.count)) {
            this.totalNewNotifications = badgeCounts.notificationCount.count;
          }

          if (badgeCounts.cartCount && (this.cart_length != badgeCounts.cartCount.count)) {
            this.cart_length = badgeCounts.cartCount.count;
            if (this.cart_length > 10) {
              this.cart_length = 10;
            }
          }
        }
      });
    this.unsubscribe.push(sub2);

    this.srHubConnection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(environment.aiApiUrl + '/notify')
      .build();

    this.srHubConnection.start().then(() => {

      var authModel = this.authMyfileService.getAuthFromLocalStorage();

      if (authModel) {
        this.srHubConnection?.invoke("JoinGroup", authModel?.jwtAccessToken?.accessToken);
      }
    }).catch(function (err) {
      return console.error(err.toString());
    });

    this.srHubConnection.on("BroadcastMessage", (message: any) => {
      this.toasterNotificationService.showInfo(
        message,
        $localize`:@@Toast_Title_SystemMessage: System Message`);
    });

    this.srHubConnection.on("SendMessage", (userName: string, message: string) => {
      this.toasterNotificationService.showInfo(
        message,
        $localize`:@@Toast_Title_SystemMessage: ${userName} Message`);
    });

    this.srHubConnection.on("UpdateInstantNotification", () => {
      this.getNotificationMessages();
    });

    this.srHubConnection.on("UpdateBadgeCounts", (userName: string) => {
      this.badgeCountService.getBadgeCount()
    });

    this.srHubConnection.on("UpdateUserContext", (username: string, message: string) => {

      if (this.authMyfileService.isInRole(Roles.admin) || this.authMyfileService.isInRole(Roles.globalAdmin)) {
        this.toasterNotificationService.showInfo(message, $localize`:@@Toast_Title_SystemMessage: System Message`);
      }

      var sub1: Subscription = this.authMyfileService.getUserContext().subscribe((result: UserContextType) => {
        if (result) {

        }
      });
      this.unsubscribe.push(sub1);
    });

    this.srHubConnection.on("SignOut", (userName: string, delayInSeconds: number, message: string) => {

      var options = {
        progressBar: true,
        timeOut: delayInSeconds * 1000,
        closeButton: false,
      };

      if (!message) {
        message = $localize`:@@Toast_ForceLogout: Menu: Logout in ${delayInSeconds} seconds.`;
      }

      this.toasterNotificationService
        .showWarning(message, $localize`:@@Toast_Title_SystemMessage: System Message`, options);

      setTimeout(() => {
        this.logout();
      },
        options.timeOut);
    });
    //** end of push init */

    //profile pic init
    if (this.userContext?.user?.profilePhotoFileId) {

      this.myfileApiService.getEntityFile(this.entityType!, this.userContext.id!, this.userContext.user.profilePhotoFileId).subscribe(result => {
        if (result) {
          var reader = new FileReader();
          reader.readAsDataURL(result);
          reader.onload = () => {
            if (reader.result) {
              this.userAvatar = reader.result.toString().split(',')[1];
              this.aiChatModalService.setProfile(this.userAvatar);
            }
          }
        }
      });
    }
    //** end of profile pic init */
    this.userContext.businessUnitId;
    var sub3: Subscription = this.myfileApiService.getBusinessUnitForCurrentUser().subscribe(result => {
      if (result) {
        this.currentTenant = result;
      }
    });
    this.unsubscribe.push(sub3);

    if (localStorage.getItem('toast')) {
      this.toasterNotificationService.showSuccess(
        $localize`:@@Toast_LoginSuccess: Logged in successfully`,
        $localize`:@@Toast_Title_SystemMessage: System Message`);
      localStorage.removeItem('toast');
    }



    var blogListSub = this.blogListService.resultItems$.subscribe(result => {
      result = Object.assign([], result);
      if (result[0] && (result[0].isPublic == true)) {
        if (this.authMyfileService.currentUserContextValue && this.authMyfileService.currentUserContextValue.id) {
          var idOfLastViewedInsight = this.blogListService.getViewedMostRecentInsight(this.authMyfileService.currentUserContextValue.id);
          if (idOfLastViewedInsight !== null && idOfLastViewedInsight !== result[0].id) {
            this.viewBlogModalService.openModal(result[0]);
          } else if (idOfLastViewedInsight === null) {
            this.viewBlogModalService.openModal(result[0]);
          }
        }
      }
    });

    this.blogListService.pageSize = this.blogListService.pageSize;
    this.unsubscribe.push(blogListSub);

    this.isAIChatVisible = this.authMyfileService.loginTypeIsUser() && !this.authMyfileService.isInRole(Roles.guest);

  }

  get rolesValue() {
    var stringReturn: string = ""
    this.userContext?.authContext?.roles.forEach((role: any) => {
      if (stringReturn === "") {
        stringReturn = `${role}`
      } else {
        stringReturn = `${role},  ${stringReturn}`
      }
    });
    return stringReturn;
  }

  getNotificationCount() {
    this.myfileApiService.getNotificationCount()
      .subscribe((result: NotificationCountResult) => {
        if (result) {
          this.totalNewNotifications = result.count;
        }
      });
  }

  profilePhotoPNGTransform() {
    if (this.userAvatar) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.userAvatar}`);
    }
    return 'assets/images/users/user-dummy-img.jpg';
  }

  updateBadgeCounts(badgeCounts: BadgeCountResults | undefined) {
    if (badgeCounts) {

      if (badgeCounts.notificationCount) {
        this.totalNewNotifications = badgeCounts.notificationCount.count;
      }

      if (badgeCounts.cartCount) {
        this.cart_length = badgeCounts.cartCount.count;
        if (this.cart_length > 10) {
          this.cart_length = 10;
        }
      }
    }
  }

  getBadgeCounts() {
    this.badgeCountService.getBadgeCount();
  }

  getNotificationMessages() {
    this.myfileApiService.getNotificationMessages()
      .subscribe((notifications: Array<NotificationResult> | undefined) => {
        if (notifications) {
          this.totalNewNotifications = notifications.length;
          this.toasterNotificationService.showInfo(
            `You received ${this.totalNewNotifications} notification(s)`,
            $localize`:@@Toast_Title_SystemMessage: System Message`);
        }
      });
  }


  openCartDropDown(event: any) {
    this.requisitionCartListService.status = RequisitionStatus.Draft;
  }

  querySelector(elementId: string) {
    if (document.getElementById(elementId)!.getAttribute('aria-expanded') == "false") {

      this.notificationUpdate = true;
      document.getElementById('page-topbar')?.classList.add("dropdownIndex");
      document.getElementById('page-topbar')?.classList.add("show");
    } else {
      document.getElementById('page-topbar')?.classList.remove("dropdownIndex");
      document.getElementById(elementId)?.classList.remove("show");
      this.notificationUpdate = false;
    }
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
    if (document.documentElement.clientWidth <= 1024) {
      if (document.documentElement.getAttribute('data-layout') == 'vertical') {
        (document.documentElement.getAttribute('data-sidebar-size') == "sm") ? document.documentElement.setAttribute('data-sidebar-size', 'lg') : document.documentElement.setAttribute('data-sidebar-size', 'sm')
      }
      if (document.documentElement.getAttribute('data-layout') == 'horizontal')
        document.body.classList.toggle('menu');
    }
    if (document.documentElement.clientWidth <= 767) {
      document.body.classList.toggle('vertical-sidebar-enable');
      document.documentElement.setAttribute('data-sidebar-size', 'lg')
    }
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
  * Topbar Light-Dark Mode Change
  */
  changeMode(mode: string) {
    this.mode = mode;

    switch (mode) {
      case 'light':
        // document.body.setAttribute('data-layout-mode', "light");
        // document.body.setAttribute('data-sidebar', );
        document.documentElement.setAttribute('data-layout-mode', mode);
        document.documentElement.setAttribute('data-sidebar', mode);

        break;
      case 'dark':
        // document.body.setAttribute('data-layout-mode', "dark");
        // document.body.setAttribute('data-sidebar', "dark");
        document.documentElement.setAttribute('data-layout-mode', mode);
        document.documentElement.setAttribute('data-sidebar', mode);

        break;
      default:
        //document.body.setAttribute('data-layout-mode', "light");

        document.documentElement.setAttribute('data-layout-mode', mode);

        break;
    }

    if (this.pref) {
      this.pref.theme.sidebar = mode;
      this.pref.theme.mode = mode;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  /***
   * Language Value Set
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.languageService.setLanguage(lang);

    this.pref.language = lang;

    var options = {
      progressBar: true,
      timeOut: 5000,
      closeButton: false,
    };

    this.userPreferenceService.updatePreference(this.pref)
      .subscribe((success: boolean) => {
        if (success) {
          setTimeout(() => {
            location.reload();
          },
            options.timeOut);
        }
      });

    this.toasterNotificationService.showWarning(
      $localize`:@@Toast_Preferences_Language_Success: Menu: Reloading the page 5 seconds.`,
      $localize`:@@Toast_Title_SystemMessage: System Message`,
      options);
  }

  /**
   * Logout the user
   */
  logout() {
    this.closeSingalRConnection();
    this.userPreferenceService.clear();
    this.authMyfileService.logout();
  }

  windowScroll() {

    if ((document.body.scrollTop > 100 || document.documentElement.scrollTop > 100)) {
      (document.getElementById("back-to-top") as HTMLElement).style.display = "block";
    } else {
      (document.getElementById("back-to-top") as HTMLElement).style.display = "none";
    }


  }

  // Delete Item
  deleteItem(event: any, id: any) {
    var price = event.target.closest('.dropdown-item').querySelector('.item_price').innerHTML;
    var Total_price = this.total - price;
    this.total = Total_price;
    this.cart_length = this.cart_length - 1;
    this.total > 1 ? (document.getElementById("empty-cart") as HTMLElement).style.display = "none" : (document.getElementById("empty-cart") as HTMLElement).style.display = "block";
    document.getElementById('item_' + id)?.remove();
  }

  openClientModalProfile() {
    this.myClientModalService.openModal();
  }

  /**
   * Search Close Btn
   */
  private closeSingalRConnection() {
    if (this.srHubConnection) {
      var authModel = this.authMyfileService.getAuthFromLocalStorage();

      if (authModel) {
        this.srHubConnection?.invoke("ExitGroup", authModel?.jwtAccessToken?.accessToken)
          .then(() => {
            this.srHubConnection?.stop();
          });
      }
    }
  }

  ngOnDestroy() {
    this.closeSingalRConnection();
    this.blogListService.clearListService();
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  openAIChat() {
    if (this.aiChatModalService.isOpened()) {
      this.aiChatModalService.closeModal();
    } else {
      this.aiChatModalService.openModal(false);
    }
  }

  openModalEdit(modalType: any, modelId: string, event?: any, otherModel?: any) {
    if (!this.submitted) {
      this.submitted = true;

      if (event) {
        event.stopPropagation();
      }
      if (modalType == ModalType.RequisitionModal) {
        this.myfileApiService.getRequisition(modelId)
          .subscribe((requisition: RequisitionModel|undefined) => {
            if (requisition) {
              if (requisition.id) {
                this.reqViewData.requisition = requisition;
                this.myRequisitionModalService.openModal(this.reqViewData);
                var sub: Subscription = this.myRequisitionModalService.modelChanged.subscribe((result: any) => {

                  sub.unsubscribe();
                  this.submitted = false;
                });
              } else {
                this.submitted = false;
              }
            }
          });
      }
    }
  }

  cartOpen(cartOpen: boolean) {
    if (cartOpen) {
      if (this.requisitionCartListService.status != RequisitionStatus.Draft) {
        this.requisitionCartListService.status = RequisitionStatus.Draft
      }
      this.requisitionCartListService.startIndex = 1;

      this.requisitionCartListService.pageSize = GlobalComponent.defaultPagingInfo.pageSize;
      this.requisitionCartList.subscribe(result => {
        if (result) {
          this.requisitionsCart = [];
          this.totalCost = 0;
          this.requisitionsCart = Object.assign([], result);
          this.requisitionsCart.forEach((data: any) => {
            if (!data.fullName) {
              data.fullName = `${data.name} ${data.lastName}`;
            }
            if (!data.client) {
              data.client = new ClientModel();
            }
            if (!data.account) {
              data.account = new ContactModel();
            }
            this.totalCost += data.total;
            data.img = this.getDocumentImageUrl(data.imageUrl);
          });
        }
      });
    }
  }

  getDocumentImageUrl(requisitionURL: string): string {
    if (requisitionURL) {
      var filename = requisitionURL.split('/').pop();

      if (filename && filename.includes("120.png")) {
        filename = "myfile_border.jpg";
      }
      return environment.staticImageApiUrl + filename;
    }
    else {
      return GlobalComponent.defaultDocumentImageUrl;
    }
  }

  showArrow(): boolean {
    if ((document.documentElement.getAttribute("data-sidebar-size") == "sm")) {
      return true
    }
    return false
  }

  shortenText(string?: string): string {
    return GlobalComponent.ellipsesString(string, 15);
  }

  toggleActivity() {
    const recentActivity = document.querySelector('.layout-rightside-col');
    if (recentActivity != null) {
      recentActivity.classList.toggle('d-none');
    }

    if (document.documentElement.clientWidth <= 1399) {
      const recentActivity = document.querySelector('.layout-rightside-col');
      if (recentActivity != null) {
        recentActivity.classList.add('d-block');
        recentActivity.classList.remove('d-none');
      }
    }
  }
  /**
 * SidebarHide modal
 * @param content modal content
 */
  SidebarHide() {
    const recentActivity = document.querySelector('.layout-rightside-col');
    if (recentActivity != null) {
      recentActivity.classList.remove('d-block');
    }
  }
}
